import { cloneDeep, isNil } from 'lodash';

import { AudioFilesEditorOutput, SSMLAudio } from '../audio-files-editor-output';
import { AudioFilesEditorFormType } from '../audio-files-form-type';
import { defaultAudioFilesEditorOutput } from '../default-audio-files';

export const formToAudioFilesEditorOutput = (params: {
  formType: AudioFilesEditorFormType;
  audioByLanguage: Record<string, SSMLAudio>;
}): AudioFilesEditorOutput => {
  if (isNil(params) || isNil(params.formType)) {
    return cloneDeep(defaultAudioFilesEditorOutput);
  }

  const result: AudioFilesEditorOutput = {
    displayName: params.formType.displayName,
    currentLanguage: params.formType.currentLanguage,
    audioByLanguage: { ...params.audioByLanguage },
  };

  return result;
};
